import React, { useState } from 'react';
import { DollarSign, ArrowDownCircle, Clock, CheckCircle, ExternalLink, Wallet, Building, Zap } from 'lucide-react';

const T = { bg2:'#0d1114', border:'rgba(255,255,255,.06)', muted:'#4a5a63', green:'#00c566' };

export default function Payouts() {
  const [tab, setTab]       = useState('withdraw');
  const [method, setMethod] = useState('usdc');
  const [loading, setLoading] = useState(false);
  const pending = 12.45, total = 48.20;

  const HISTORY = [
    {id:1,amount:5.20,date:'Aug 1, 2026',method:'USDC Wallet',tx:'0x123...abc'},
    {id:2,amount:8.40,date:'Jul 28, 2026',method:'OPay',tx:null},
    {id:3,amount:3.10,date:'Jul 20, 2026',method:'USDC Wallet',tx:'0x456...def'},
  ];

  return (
    <div>
      <h1 style={{ fontSize:'clamp(20px,4vw,28px)', fontWeight:800, marginBottom:4 }}>Payouts</h1>
      <p style={{ fontSize:14, color:T.muted, marginBottom:20 }}>Withdraw your creator royalties</p>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(150px,1fr))', gap:12, marginBottom:20 }}>
        {[[Zap,'Available','$'+pending.toFixed(2),'#00c566'],[DollarSign,'Total Earned','$'+total.toFixed(2),'#f5c842'],[CheckCircle,'Withdrawn','$'+(total-pending).toFixed(2),'#4a5a63']].map(([Icon,label,val,color])=>(
          <div key={label} style={{ background:T.bg2, border:`1px solid ${T.border}`, borderRadius:14, padding:18 }}>
            <Icon size={16} color={color} style={{ marginBottom:10 }}/>
            <div style={{ fontSize:24, fontWeight:800, color }}>{val}</div>
            <div style={{ fontSize:12, color:T.muted, marginTop:3 }}>{label}</div>
          </div>
        ))}
      </div>

      <div style={{ display:'flex', gap:8, marginBottom:20 }}>
        {['withdraw','history'].map(t=>(
          <button key={t} onClick={()=>setTab(t)} style={{ padding:'8px 20px', borderRadius:8, border:`1px solid ${t===tab?'rgba(0,197,102,.3)':T.border}`, background:t===tab?'rgba(0,197,102,.08)':'rgba(255,255,255,.03)', color:t===tab?T.green:T.muted, cursor:'pointer', fontSize:13, fontWeight:600, fontFamily:'inherit', textTransform:'capitalize' }}>{t}</button>
        ))}
      </div>

      {tab==='withdraw' && (
        <div style={{ maxWidth:480 }}>
          <div style={{ background:T.bg2, border:`1px solid ${T.border}`, borderRadius:16, padding:20, marginBottom:14 }}>
            <div style={{ fontSize:14, fontWeight:700, marginBottom:14 }}>Withdrawal Method</div>
            {[{id:'usdc',Icon:Wallet,title:'USDC Wallet',desc:'Send to Ethereum wallet'},{id:'bank',Icon:Building,title:'Nigerian Bank',desc:'Via Flutterwave — OPay, GTBank, etc.'}].map(({id,Icon,title,desc})=>(
              <div key={id} onClick={()=>setMethod(id)} style={{ display:'flex', alignItems:'center', gap:12, padding:14, borderRadius:12, border:`1px solid ${method===id?'rgba(0,197,102,.3)':T.border}`, background:method===id?'rgba(0,197,102,.04)':'rgba(255,255,255,.02)', cursor:'pointer', marginBottom:10 }}>
                <div style={{ width:38, height:38, borderRadius:10, background:method===id?'rgba(0,197,102,.1)':'rgba(255,255,255,.04)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <Icon size={17} color={method===id?T.green:T.muted}/>
                </div>
                <div style={{ flex:1 }}>
                  <div style={{ fontSize:14, fontWeight:600, color:method===id?T.green:'#e8eaeb' }}>{title}</div>
                  <div style={{ fontSize:12, color:T.muted }}>{desc}</div>
                </div>
                <div style={{ width:18, height:18, borderRadius:'50%', border:`2px solid ${method===id?T.green:'#2a3540'}`, display:'flex', alignItems:'center', justifyContent:'center' }}>
                  {method===id&&<div style={{ width:8, height:8, borderRadius:'50%', background:T.green }}/>}
                </div>
              </div>
            ))}
          </div>

          <div style={{ background:T.bg2, border:`1px solid ${T.border}`, borderRadius:16, padding:20, marginBottom:14 }}>
            {method==='usdc'?(
              <div>
                <label style={{ display:'block', fontSize:12, color:T.muted, fontWeight:600, letterSpacing:.5, marginBottom:6 }}>USDC WALLET ADDRESS</label>
                <input placeholder="0x..." style={{ background:'rgba(255,255,255,.04)', border:`1px solid ${T.border}`, borderRadius:10, padding:'12px 14px', color:'#e8eaeb', fontSize:14, width:'100%', outline:'none', fontFamily:'monospace' }}/>
              </div>
            ):(
              <div>
                <label style={{ display:'block', fontSize:12, color:T.muted, fontWeight:600, letterSpacing:.5, marginBottom:6 }}>BANK NAME</label>
                <select style={{ background:'rgba(255,255,255,.04)', border:`1px solid ${T.border}`, borderRadius:10, padding:'12px 14px', color:'#e8eaeb', fontSize:14, width:'100%', outline:'none', fontFamily:'inherit', marginBottom:12 }}><option>OPay</option><option>GTBank</option><option>Access Bank</option><option>Zenith Bank</option><option>Moniepoint</option></select>
                <label style={{ display:'block', fontSize:12, color:T.muted, fontWeight:600, letterSpacing:.5, marginBottom:6 }}>ACCOUNT NUMBER</label>
                <input placeholder="10-digit account number" style={{ background:'rgba(255,255,255,.04)', border:`1px solid ${T.border}`, borderRadius:10, padding:'12px 14px', color:'#e8eaeb', fontSize:14, width:'100%', outline:'none', fontFamily:'inherit' }}/>
              </div>
            )}
          </div>

          <div style={{ background:'rgba(255,255,255,.02)', border:`1px solid ${T.border}`, borderRadius:16, padding:20, marginBottom:16 }}>
            {[['Available','$'+pending.toFixed(2)],['Fee','FREE'],method==='bank'?['Rate','$1 = ₦1,650']:null].filter(Boolean).map(([k,v])=>(
              <div key={k} style={{ display:'flex', justifyContent:'space-between', fontSize:13, padding:'6px 0', borderBottom:`1px solid ${T.border}` }}>
                <span style={{ color:T.muted }}>{k}</span><span style={{ fontWeight:600, color:v==='FREE'?T.green:'#e8eaeb' }}>{v}</span>
              </div>
            ))}
            <div style={{ display:'flex', justifyContent:'space-between', fontSize:15, paddingTop:10 }}>
              <span style={{ fontWeight:700 }}>You Receive</span>
              <span style={{ fontWeight:800, color:T.green }}>{method==='usdc'?`$${pending.toFixed(2)} USDC`:`₦${(pending*1650).toLocaleString()}`}</span>
            </div>
          </div>

          <button onClick={()=>{ setLoading(true); setTimeout(()=>{setLoading(false);alert('Withdrawal initiated!');},2000); }} disabled={loading||pending<1}
            style={{ width:'100%', padding:14, borderRadius:12, border:'none', background:'linear-gradient(135deg,#00c566,#00a854)', color:'#000', fontWeight:700, fontSize:15, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8, fontFamily:'inherit', opacity:pending<1?.5:1 }}>
            <ArrowDownCircle size={17}/>{loading?'Processing...':'Withdraw $'+pending.toFixed(2)+' USDC'}
          </button>
        </div>
      )}

      {tab==='history' && (
        <div style={{ background:T.bg2, border:`1px solid ${T.border}`, borderRadius:16, padding:20 }}>
          <div style={{ fontSize:15, fontWeight:700, marginBottom:14 }}>Withdrawal History</div>
          {HISTORY.map(h=>(
            <div key={h.id} style={{ display:'flex', alignItems:'center', gap:12, padding:'13px 0', borderBottom:`1px solid ${T.border}` }}>
              <div style={{ width:38, height:38, borderRadius:10, background:'rgba(0,197,102,.08)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                <CheckCircle size={16} color={T.green}/>
              </div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontSize:14, fontWeight:600 }}>{h.method}</div>
                <div style={{ fontSize:12, color:T.muted, display:'flex', alignItems:'center', gap:4 }}><Clock size={10}/>{h.date}</div>
              </div>
              <div style={{ textAlign:'right' }}>
                <div style={{ fontSize:15, fontWeight:700, color:T.green }}>${h.amount.toFixed(2)}</div>
                {h.tx&&<a href={`https://sepolia.etherscan.io/tx/${h.tx}`} target="_blank" rel="noreferrer" style={{ fontSize:11, color:T.muted, display:'flex', alignItems:'center', gap:3, justifyContent:'flex-end', marginTop:2 }}><ExternalLink size={10}/>TX</a>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
